var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBasicProductInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20360 -1865)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20360 1865)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20354.648 1871.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3662.778,4155c-1.133,0-2.266,0-3.4,0a2.065,2.065,0,0,1-2.2-2.137q-.041-2.75,0-5.5a2.038,2.038,0,0,1,2.125-2.114q3.511-.021,7.023,0a1.985,1.985,0,0,1,2.047,2.08q.016,2.795,0,5.591a2.03,2.03,0,0,1-2.1,2.08C-3660.452,4155-3661.615,4155-3662.778,4155Zm-1.339-4.89c0-.912-.009-1.667,0-2.421,0-.294-.078-.446-.4-.436-.477.015-.954.011-1.431,0-.261,0-.375.092-.374.366q.011,2.481,0,4.962c0,.256.072.375.355.374q3.2-.012,6.392,0c.241,0,.353-.066.352-.325-.006-1.684,0-3.368-.016-5.051a.442.442,0,0,0-.305-.307c-.5-.034-1.013-.008-1.519-.02-.274-.005-.364.114-.358.377.012.625.006,1.251,0,1.877,0,.152-.025.3-.052.6A1.778,1.778,0,0,0-3664.117,4150.108Z",
    transform: "translate(3682.472 -4132.521)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3820.088,4155.024c-1.147,0-2.294,0-3.441,0a2.062,2.062,0,0,1-2.144-2.138q-.015-2.748,0-5.5a2.037,2.037,0,0,1,2.109-2.12q3.486-.013,6.971,0a2.018,2.018,0,0,1,2.114,2.1q.014,2.747,0,5.5a2.047,2.047,0,0,1-2.167,2.152Q-3818.368,4155.027-3820.088,4155.024Zm-1.317-4.9c-.017-.321-.033-.48-.033-.64,0-.6-.013-1.192,0-1.788.008-.3-.091-.435-.407-.424-.476.017-.953.01-1.43,0-.267,0-.365.109-.364.375q.01,2.481,0,4.96c0,.268.1.366.369.365q3.195-.011,6.39,0c.234,0,.366-.065.366-.325,0-1.682,0-3.366-.016-5.049a.451.451,0,0,0-.311-.308c-.5-.034-1.012-.008-1.518-.019-.278-.006-.357.12-.351.381.013.626.007,1.251,0,1.877,0,.152-.028.3-.059.631A1.74,1.74,0,0,0-3821.405,4150.129Z",
    transform: "translate(3825.68 -4132.547)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3741,4012.924c-1.148,0-2.3,0-3.444,0a2,2,0,0,1-2.091-2.115q0-2.773,0-5.546a2,2,0,0,1,2.028-2.1q3.532-.041,7.066,0a2.011,2.011,0,0,1,2.062,2.131q.051,2.794,0,5.59a2,2,0,0,1-2.133,2.042C-3738.674,4012.926-3739.837,4012.924-3741,4012.924Zm-1.339-5.01c0-.767-.014-1.52.006-2.274.009-.338-.111-.445-.439-.428a10.724,10.724,0,0,1-1.3,0c-.357-.024-.46.1-.456.454.018,1.415.007,2.832.007,4.247v.929a1.359,1.359,0,0,0,.26.061q3.264.006,6.527.008c.253,0,.326-.113.325-.355q-.012-2.481,0-4.963c0-.3-.111-.389-.395-.378a11.651,11.651,0,0,1-1.3,0c-.389-.028-.53.1-.516.5.028.723.008,1.448.008,2.179A13.332,13.332,0,0,0-3742.339,4007.914Z",
    transform: "translate(3753.617 -4003.139)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasicProductInfo);
export default __webpack_public_path__ + "static/media/icon-basic-product-info.589e53fc.svg";
export { ForwardRef as ReactComponent };